<lib-lang-droplist class="lang-switcher"></lib-lang-droplist>

<form [formGroup]="form" (ngSubmit)="handleLoginClick()">
  <div class="login-wrapper">
    @if (!redirecting) {
      <h1 class="mb-5">{{ 'login.log_in' | transloco }}</h1>
      @if (respState === 'success') {
        <div class="info success mb-5">
          {{ 'login.we_sent_you_email' | transloco: { email: form.controls.email.value } }}
        </div>
      }
      @if (respState === 'error') {
        <p class="info error mb-2">{{ 'login.something_went_wrong' | transloco }}</p>
      }
      @if (respState === 'expiredCode' || respState === 'link_depleted' || respState === 'link_inactive') {
        <p class="info error mb-5">
          {{ 'login.expired_code' | transloco }}
        </p>
      }
      @if (redirectionErrorToken) {
        <p class="info error mb-5">
          {{ 'login.failed_starting_survey' | transloco: { token: redirectionErrorToken } }}
        </p>
      }
      @if (respState !== 'success') {
        <mat-form-field class="mb-3">
          <mat-label>{{ 'login.enter_email_label' | transloco }}</mat-label>
          <input [formControl]="form.controls.email" matInput type="text" autocomplete="email" />
        </mat-form-field>
        <p class="desc mb-5">{{ 'login.description' | transloco }}</p>
      }
      @if (respState === 'success') {
        <button class="btn btn-primary w-100" (click)="respState = 'none'">
          @if (!loading) {
            <span> {{ 'login.done' | transloco }}</span>
          } @else {
            <div class="spinner-container p-absolute">
              <mat-spinner class="white" [diameter]="20"></mat-spinner>
            </div>
          }
        </button>
      }
      @if (respState !== 'success') {
        <button [disabled]="form.invalid && form.touched" class="btn btn-primary w-100" type="submit">
          @if (!loading) {
            <span>{{ 'login.log_in' | transloco }}</span>
          } @else {
            <div class="spinner-container p-absolute">
              <mat-spinner class="white" [diameter]="20"></mat-spinner>
            </div>
          }
        </button>
      }
    } @else {
      <div class="error-container">
        <h2>{{ 'login.redirecting' | transloco }}</h2>
        <div class="loading-container">
          <lib-loading-column-animation></lib-loading-column-animation>
        </div>
      </div>
    }
  </div>
</form>
